
import React, { Component } from 'react';
import { Button } from 'reactstrap';

const dateUtil = require('../../../../utils/dateUtil/dateUtil');
const translator = require('../../../../utils/translator/translator');

class HourStepCounter extends Component
{
    render()
    {
        return (
            <div className='d-flex flex-column'>

                <div className='mb-2 d-flex justify-content-between align-items-center border-bottom'>
                    <div>{this.props.label}</div>
                    <div className='text-muted text-wrap' style={{ fontSize: "0.75em" }}>
                        {this.getSnoozeExpiry(this.props.hours)}
                    </div>
                </div>

                <div className='d-flex justify-content-between align-items-center'>

                    <div style={{ width: "200px", height: "50px" }} class="mr-4 d-flex border rounded">

                        <Button
                            color="dark" className="px-4 h-100 d-flex align-items-center" style={{ fontSize: "2em" }}
                            onClick={this.props.onDecrement}>-</Button>

                        <div
                            className='px-4 h-100 d-flex justify-content-center align-items-center flex-grow-1 font-weight-bold text-muted'
                            style={{ fontSize: "1.5em" }}>{this.props.hours}</div>

                        <Button
                            color="dark" className="px-4 h-100 d-flex align-items-center" style={{ fontSize: "2em" }}
                            onClick={this.props.onIncrement}>+</Button>

                    </div>

                    <div style={{ height: "50px", fontSize: "1.5em" }}>
                        <Button color="primary" className='h-100 px-4' onClick={this.props.onSave}>
                            <i className='fa fa-floppy-o' />&nbsp;{translator.getLabel('append_snooze')}
                        </Button>
                    </div>

                </div>

            </div>
        );
    }

    getSnoozeExpiry(selectedHours)
    {
        if (selectedHours === 0) return null;

        const expiry = dateUtil.addHours(dateUtil.getNow(), selectedHours);
        return `${translator.getLabel('snoozed_until')} ${dateUtil.formatDate(dateUtil.convertToLocalStandard(expiry), "DD MMMM yyyy, HH:mm")}`;
    }
}

export default HourStepCounter;